import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"
import Modal from "@amzn/meridian/modal"
import Button from "@amzn/meridian/button"
import Column from "@amzn/meridian/column"
import Heading from "@amzn/meridian/heading"
import Row from "@amzn/meridian/row"
import Text from "@amzn/meridian/text"

const IssuesModal = props => {
  const { buttonTitle, data, modalTitle, riverWorkflows } = props;
  const [open, setOpen] = useState(false);
  const onClickButton = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => {
      setOpen(false)
  }, []);

  return (
    <React.Fragment>
      <Button
        size="small"
        minWidth="8%"
        onClick={onClickButton}
      >
        {buttonTitle}
      </Button>
      <Modal
        title={modalTitle}
        open={open}
        onClose={onClose}
        scrollContainer="viewport"
        closeLabel="Close"
        aria-describedby={modalTitle}
        width={"100vw"}
      >
        <Column>
          {/* Add any information that may be needed while entering a ticket */}
          <Row>
            {data.loadId && <Row spacing={"200"}><Heading level={6}>Order ID:</Heading><Text>{data.loadId}</Text></Row>}
            {data.source && <Row spacing={"200"}><Heading level={6}>Source:</Heading><Text>{data.source}</Text></Row>}
          </Row>
          {/*  Loop all the riverWorkflows here as buttons that open in new tabs */}
          <Row spacing="200">
            {riverWorkflows.map((workflow, index) => {
              return (
                <Button
                  key={index}
                  size="small"
                  onClick={() => window.open(workflow.url, '_blank', 'noopener,noreferrer')}
                >
                  {workflow.title}
                </Button>
              )
            })}
          </Row>
        </Column>
      </Modal>
    </React.Fragment>
  )
}

IssuesModal.propTypes = {
  buttonTitle: PropTypes.string.isRequired,
  data: PropTypes.object,
  modalTitle: PropTypes.string.isRequired,
  riverWorkflows: PropTypes.object.isRequired,
}

export default IssuesModal;
